import React from 'react';
import { Bell, Search } from 'lucide-react';

const TopBar = () => {
  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center px-8">
      <div className="flex-1 flex items-center">
        <div className="max-w-lg w-full relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search summaries, follow-ups, contacts..."
            className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
          />
        </div>
      </div>
      
      <div className="flex items-center gap-4">
        <button className="relative p-2 text-gray-600 hover:bg-gray-50 rounded-lg">
          <Bell className="h-5 w-5" />
          <span className="absolute top-1 right-1 h-2 w-2 bg-primary rounded-full" />
        </button>
        <div className="h-8 w-8 rounded-full bg-gray-200" />
      </div>
    </header>
  );
};

export default TopBar;